import { render, staticRenderFns } from "./McLayoutForm.vue?vue&type=template&id=2dd09b5e"
import script from "./McLayoutForm.vue?vue&type=script&lang=js"
export * from "./McLayoutForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports